import Vue from 'vue';
import VueRouter from 'vue-router';
import Conversation from '@/views/Conversation';
import ServiceRequest from '@/views/ServiceRequest';
import NotFound from '@/views/NotFound';
import DATConnectionError from '@/views/DATConnectionError';
import VehicleIdentificationParent from '@/components/vehicleIdentification/VehicleIdentificationParent';
import VinSelection from '@/components/vehicleIdentification/VinSelection';
import CatalogIdentification from '@/components/vehicleIdentification/CatalogIdentification';
import HsnTsnSelection from '@/components/vehicleIdentification/HsnTsnSelection';
import NoSelectionAllowed from '@/components/vehicleIdentification/NoSelectionAllowed';
import RegionSelection from '@/components/serviceSelection/RegionSelection';
import ServiceSelection from '@/components/serviceSelection/ServiceSelection';
import CancelOffer from '@/components/service-request/CancelOffer';
import BookedOffer from '@/components/service-request/BookedOffer';
import Offer from '@/components/service-request/Offer';
import Rejected from '@/components/service-request/Rejected';
import OfferExpired from '@/components/service-request/OfferExpired';
import Confirmed from '@/components/service-request/Confirmed';
import EquipmentSelection from '@/components/equipmentSelection/EquipmentSelection';
import OfferSelection from '@/components/offerSelection/OfferSelection';
import WorkshopRating from '@/components/service-request/WorkshopRating';
import WorkshopRatingSuccess from '@/components/service-request/WorkshopRatingSuccess';
import tabs from '@/constants/tabs';
import store from '@/store'
import utils from '@/util/utils';
import SimpleServiceRoutes from '@/modules/simpleService/router';
import smpConfigUtil from '@/util/smp_config_utils';
import LicensePlateIdentification from '@/components/vehicleIdentification/LicensePlateIdentification.vue';

Vue.use(VueRouter);
const updateServiceRoute = (to, from, next) => {
  tabs.main[0].href = to.path;
  store.commit('tab/SET_TABS', tabs.main);
  store.commit('wizardData/SET_PREV_ROUTES', to.name);
  next();
};

const getRoutes = () => {
  let routes = [{
    name: 'booking',
    path: '/booking/:key',
    component: BookedOffer,
    beforeEnter: updateServiceRoute
  },
  {
    name: 'cancelbooking',
    path: '/booking/:key/cancel',
    component: CancelOffer,
    beforeEnter: (to, from, next) => {
      tabs.reject[0].href = to.path;
      store.commit('tab/SET_TABS', tabs.reject);
      next();
    }
  },
  {
    name: 'workshopRating',
    path: '/booking/:key/rating',
    component: WorkshopRating,
    beforeEnter: (to, from, next) => {
      tabs.rating[0].href = to.path;
      store.commit('tab/SET_TABS', tabs.rating);
      next();
    }
  },
  {
    name: 'workshopRatingSuccess',
    path: '/booking/:key/rating/success',
    component: WorkshopRatingSuccess,
    beforeEnter: updateServiceRoute
  },
  {
    path: '*',
    component: NotFound
  }];
  if (utils.isSingleService()) {
    routes = [
      ...routes,
      ...SimpleServiceRoutes,
      {
        path: '/service-request/rejected',
        component: Rejected
      }
    ];
  } else {
    if (!smpConfigUtil.getDatConnectionConfig().active) {
      return [{
        path: '*',
        component: DATConnectionError
      }];
    }
    routes = [
      ...routes,
      {
        path: '/',
        component: ServiceRequest,
        redirect: '/service-request'
      },
      {
        path: '/service-request',
        component: ServiceRequest,
        children: [
          {
            path: 'rejected',
            component: Rejected
          },
          {
            path: '/service-request/offer-expired',
            component: OfferExpired,
            beforeEnter: updateServiceRoute
          },
          {
            path: 'confirm/:key',
            component: Confirmed,
            beforeEnter: updateServiceRoute
          },
          {
            name: 'VehicleIdentification',
            path: 'vehicle-identification',
            component: VehicleIdentificationParent,
            children: [
              {
                name: 'CatalogIdentification',
                path: 'catalog-selection',
                component: CatalogIdentification,
                beforeEnter: updateServiceRoute
              }, {
                name: 'HsnTsnSelection',
                path: 'hsn-tsn-selection',
                component: HsnTsnSelection,
                beforeEnter: updateServiceRoute
              }, {
                name: 'VinSelection',
                path: 'vin-selection',
                component: VinSelection,
                beforeEnter: updateServiceRoute
              }, {
                name: 'LicensePlateIdentification',
                path: 'license-plate-selection',
                component: LicensePlateIdentification,
                beforeEnter: updateServiceRoute
              }, {
                name: 'NoSelectionAllowed',
                path: 'no-selection-allowed',
                component: NoSelectionAllowed,
                beforeEnter: updateServiceRoute
              }
            ]
          },
          {
            name: 'RegionSelection',
            path: 'region-selection',
            component: RegionSelection,
            beforeEnter: updateServiceRoute
          },
          {
            name: 'ServiceSelection',
            path: 'service-selection',
            component: ServiceSelection,
            beforeEnter: updateServiceRoute
          },
          {
            name: 'EquipmentSelection',
            path: 'equipment-selection',
            component: EquipmentSelection,
            beforeEnter: updateServiceRoute
          },
          {
            name: 'offer',
            path: 'offer/:key',
            component: Offer,
            beforeEnter: updateServiceRoute
          }
        ],
        redirect: { name: 'VehicleIdentification' }
      },
      {
        name: 'OfferSelection',
        path: '/searches/:searchKey',
        component: OfferSelection,
        beforeEnter: updateServiceRoute
      },
      {
        name: 'conversation',
        path: '/conversation/:token?',
        component: Conversation,
        beforeEnter: (to, from, next) => {
          store.commit('tab/SET_TABS', tabs.main);
          next();
        }
      }
    ];
  }
  return routes;
}

const router = new VueRouter({
  linkActiveClass: 'car-is-active',
  routes: getRoutes()
});

if (window.top !== self) {
  router.beforeEach((to, from, next) => {
    if (window.parent.postMessage) {
      window.parent.postMessage(to.fullPath, '*');
    }
    return next();
  });
}

export default router;
